import { useQuery } from '@tanstack/react-query';
import { dashboardService, type DashboardSummary } from '@/services/api/dashboardService';

interface UseDashboardOptions {
  labId?: string;
  days?: number;
}

/**
 * Hook to fetch dashboard data with auto-refresh
 */
export function useDashboard(options?: UseDashboardOptions) {
  return useQuery<DashboardSummary>({
    queryKey: ['dashboard', options?.labId, options?.days],
    queryFn: () => dashboardService.getSummary(options),
    staleTime: 30000, // 30 seconds
    refetchInterval: 60000, // Auto-refresh every 60 seconds
    refetchOnWindowFocus: true,
  });
}
